<div class="full-width-image-container">
  <img src="../../assets/AdobeStock_3558442.jpeg" alt="Header Image">
</div>
<div class="top">
  <div>Do The <span>Right Thing</span></div>
  <div>On Point <span>With Safety</span></div>
  <div>Roll up <span>Your Sleeves</span></div>
</div>
<hr class="hr">
<br><br>
<div class="dev-msg">
  <div class="links-title">Guides & General Standards</div><br>
</div>
<p class="dev-p">
  <a routerLink="/standards" class="policy-link" routerLinkActive="active">Go Back</a>
</p>
<br>

  <div class="tab-container">
    <!--
    <mat-tab-group class="tab-group" (selectedTabChange)="onTabChange($event)">
      <mat-tab-group class="tab-group" (selectedTabChange)="onTabChange($event)">
        <mat-tab label="Landpoint General">
          -->
          <div class="tab-content">
            <app-document-picker category="Standards" subcategory="Guides" label="Select an option:"></app-document-picker>
          </div>
          <!--
        </mat-tab>
      </mat-tab-group>
      -->
    </div>

    <br><br><br>
